import Styles from './container.module.scss';
import { createElementContainer } from 'utils';

export default function createContainer() {
  const portalId = 'notifyContainer';
  return createElementContainer(portalId, Styles.container);
}
